const FULL_PIXEL_PLATFORMS = ['facebook', 'snapchat', 'tiktok', 'bing', 'criteo', 'rtbHouse'];
const LOGIN_PIXEL_PLATFORMS = ['facebook', 'snapchat', 'tiktok', 'bing'];

const FULL_PIXEL_EVENTS = new Set([
  'IsReturn_Result',
  'ProductDetailsPage_View',
  'AddToCart_Result',
  'CollectBtn_Click',
  'PlaceOrderPage_View',
  'PlaceOrderPagePlaceOrder_Result',
  'Purchase',
]);

const LOGIN_PIXEL_EVENTS = new Set(['LoginSuccessNew_Result', 'LoginSuccess_Result']);

/**
 * 根据事件名返回需要关联的广告平台 pixel 列表。
 * @param eventName - 神策事件名
 * @returns pixel 平台数组；非白名单事件返回空数组
 */
export function getSnowplowPixels(eventName: string): string[] {
  if (FULL_PIXEL_EVENTS.has(eventName)) return [...FULL_PIXEL_PLATFORMS];
  if (LOGIN_PIXEL_EVENTS.has(eventName)) return [...LOGIN_PIXEL_PLATFORMS];
  return [];
}
